import { getCurrentUser } from '@creditsights/api-ui-web';
import classNames from 'classnames/bind';
import { ReactElement, useMemo } from 'react';
import useShareWatchlistUsers from '../../../../hooks/watchLists/useShareWatchlistUsers';
import { WatchList } from '../../../../models/WatchList';
import { formatCommonDate } from '../../../../utils/dateUtils';
import styles from './WatchlistDetailsFormatter.module.scss';

const cx = classNames.bind(styles);

const WatchlistDetailsFormatter = ({ item }: { item: WatchList }): ReactElement => {
  const { data: users } = useShareWatchlistUsers();
  const ownerName = useMemo(() => users?.find((x) => x.id === item.ownerId)?.name, [item, users]);
  const { userId } = getCurrentUser();

  return (
    <div className={cx('body')}>
      <span>{formatCommonDate(item.createdAt)}</span>
      {!!item.sharedWithUsers?.length && (
        <span className={cx('shared-info')}>Shared ({item.sharedWithUsers.length})</span>
      )}
      {item.ownerId !== userId && <span className={cx('owner-info')}>{ownerName}</span>}
    </div>
  );
};

export default WatchlistDetailsFormatter;
